"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return NocoSocket;
    }
});
let NocoSocket = class NocoSocket {
    static handleConnection(..._args) {}
    static broadcastEvent(..._args) {}
    static broadcastEventToBaseUsers(..._args) {}
    static broadcastEventToWorkspaceUsers(..._args) {}
    static broadcastEventToUser(..._args) {}
};
